export const DEFAULT_TIMER_VALUE = 120000;
